import { Modal } from '@carbon/react';
import { defineMessages, useIntl } from 'react-intl';

import sharedMessages from 'Components/utils/sharedMessages';
import { useUnsubscribeMutation } from 'api/subscriptionPlanEndpoints';

type Props = {
    onModalClose: () => void;
    confirmationModalOpen: boolean;

}

const UnsubscribeFromPaidPlanModal = ({
    onModalClose,
    confirmationModalOpen,
}: Props) => {
    const intl = useIntl();
    const [unsubscribe, { isLoading }] = useUnsubscribeMutation();

    const onRemove = async () => {
        try {
            await unsubscribe().unwrap();
            onModalClose();
        } catch (e) {
            // handled
        }
    };

    return (
        <Modal
            open={confirmationModalOpen}
            onRequestClose={onModalClose}
            onRequestSubmit={onRemove}
            loadingStatus={isLoading ? 'active' : undefined}
            primaryButtonDisabled={isLoading}
            danger
            modalHeading={intl.formatMessage(messages.areYouSure)}
            modalLabel={intl.formatMessage(messages.unsubscribeFromPaidPlan)}
            primaryButtonText={intl.formatMessage(sharedMessages.remove)}
            closeButtonLabel={intl.formatMessage(sharedMessages.cancel)}
            secondaryButtonText={intl.formatMessage(sharedMessages.back)}
        />
    );
};

const messages = defineMessages({
    unsubscribeFromPaidPlan: {
        id: 'src.Screens.Dashboard.Subscription.ActiveSubscription.UnsubscribeFromPaidPlanModal.unsubscribeFromPaidPlan',
        defaultMessage: 'Odsubskrybować Twój plan?',
    },
    areYouSure: {
        id: 'src.Screens.Dashboard.Subscription.ActiveSubscription.UnsubscribeFromPaidPlanModal.areYouSure',
        defaultMessage: 'Jesteś pewien, że chcesz odsubskrybować? Ta operacja spowoduje utratę dostępu do funkcji płatnych po zakończeniu bieżącego okresu rozliczeniowego.',
    },
});

export default UnsubscribeFromPaidPlanModal;
